__turbopack_context__.v({
  "emptyState": "EmptyState-module__X3JzkW__emptyState",
  "icon": "EmptyState-module__X3JzkW__icon",
});
